import React, { Component } from 'react';
import styled from 'styled-components';
import MobileStoreButton from '@ertelecom/ui-react/components/buttons/mobileStoreButton';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

const AppContainer = styled.section`
    display: none;
    width: 100%;
    background: linear-gradient(304.13deg, #FFC224 -7.96%, #FEEC8B 71.2%);
    padding: 66px 17px 70px;

    @media(max-width: 767px) {
        display: block;
    }
`;

const AppBlock = styled.div`
    width: 100%;
    background: ${ COLORS.white };
    border: 1px solid ${ COLORS.lightGrey };
    border-radius: 8px;
    padding: 46px 21px 34px;
`;

const Title = styled.h2`
    ${FONTS.H3};
    text-align: center;
    margin: 0 auto;
    color: ${ COLORS.black };
`;

const Desc = styled.div`
    ${FONTS.S};
    text-align: center;
    color: ${ COLORS.black };
    margin-top: 20px;
    margin-bottom: 20px;
`;

const AppButton = styled(MobileStoreButton)`
    width: 100%;
    margin-top: 12px;
    border: 1px solid ${ COLORS.grey };
`;

export default class AppSection extends Component {
    render() {

      return (
          <AppContainer>
              <AppBlock>
                  <Title>Личный кабинет в вашем кармане</Title>
                  <Desc as='p'>Личный кабинет в вашем телефоне с приложением Мой Дом.ру. Доступно в App Store и Google Play.</Desc>
                  <AppButton store='AppStore' color='#fff' />
                  <AppButton store='GooglePlay' color='#fff' />
              </AppBlock>
          </AppContainer>
      );
    }
}
